/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import {PasswordStrengthEvaluationRequestDTO, PasswordStrengthService} from '../../generated/iam-client';
import {from, Observable, of} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {iamApiEvaluatePasswordStrengthUnexpectedError, iamApiPasswordStrengthEvaluated} from './actions';
import {AnyAction} from 'redux';

class PasswordStrengthResource {

	evaluatePasswordStrength(evaluationRequest: PasswordStrengthEvaluationRequestDTO): Observable<AnyAction> {
		const promise = PasswordStrengthService.evaluatedPasswordStrength(evaluationRequest);

		return from(promise)
			.pipe(
				map((responseBody) => iamApiPasswordStrengthEvaluated({passwordStrength: responseBody})),
				catchError(() => of(iamApiEvaluatePasswordStrengthUnexpectedError()))
			);
	}
}

export default PasswordStrengthResource;
